export const TSL_TYPES = [
  { label: 'Small Passenger Service Licence', value: 'SPSL' },
  { label: 'Larger Passenger Service Licence', value: 'LPSL' },
  { label: 'Vehicle Recovery Service Licence', value: 'VRSL' },
  { label: 'Goods Service Licence', value: 'GSL' },
];
